import React, { useId } from 'react'
import PropTypes from 'prop-types'

const InfoCircleIcon = React.forwardRef(function InfoCircleIcon(props, ref) {
  const { color, size, ...otherProps } = props
  const clipPathId = useId()

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9 11C9 10.4477 9.44772 10 10 10H13V18C13 18.5523 12.5523 19 12 19 11.4477 19 11 18.5523 11 18V12H10C9.44772 12 9 11.5523 9 11ZM10 6.5C10 5.67157 10.6716 5 11.5 5 12.3284 5 13 5.67157 13 6.5 13 7.32843 12.3284 8 11.5 8 10.6716 8 10 7.32843 10 6.5Z"
        ></path>
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <path fill="white" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
})

InfoCircleIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

InfoCircleIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default InfoCircleIcon
